import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UIProjectGroupsRefreshService {
  readonly refresh$ = new BehaviorSubject<void>(undefined);
}
